export default "__VITE_ASSET__C2Ig7hM___"